<template>
    <v-container>
        <h1 class="mb-6">{{ metaData.header }}</h1>

        <v-row>
            <v-col cols="12" sm="12" md="6" v-for="company in companies" :key="company.id">
                <v-card :to="company.link" class="pa-4 d-flex flex-column" height="300px">
                    <v-row>
                        <v-col sm="12" md="5" class="d-flex align-center">
                            <v-img :src="company.logo" contain max-width="200px" height="80px" v-if="company.logo"></v-img>
                        </v-col>
                        <v-col sm="12" md="7">
                            <v-card-title>{{ company.name }}</v-card-title>
                            <div>
                                <v-card-text>{{ company.phone }}</v-card-text>
                                <v-card-text>{{ company.email }}</v-card-text>
                            </div>
                        </v-col>
                    </v-row>

                    <v-card-text class="text-center">
                        {{ company.address }}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import CompanyService from '../../../app-front/services/api/CompanyService'

    export default {
        name: 'Companies',
        data() {
            return {
                metaUrl: '/companies',
                companies: []
            }
        },
        created() {
            this.getCompanies()
        },
        methods: {
            getCompanies() {
                CompanyService.setLocale(this.$store.state.language.appLanguage)
                CompanyService.getCompanies()
                    .then(res => {
                        this.companies = res.data
                    })
                    .catch(() => {})
            }
        },
    }
</script>

<style scoped>

</style>
